const stats = [
  { value: "24/7", label: "Support" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-28 bg-[#F8F6F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative rounded-2xl overflow-hidden w-full h-[420px]">
            <img
              src="https://public.readdy.ai/ai/img_res/499164359337e58b03b392534dc24af2.jpg"
              alt="TIAS OOD Team"
              className="w-full h-full object-cover object-top"
            />
            {/* Accent card overlay */}
            <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-sm rounded-xl px-6 py-4">
              <p className="text-xs text-gray-500 uppercase tracking-widest font-medium">Founded in</p>
              <p className="text-2xl font-bold text-gray-900">Bulgaria</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-amber-600 text-xs font-semibold uppercase tracking-widest">Who We Are</span>
            <h2 className="mt-3 text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              Experts in Modern <br />iOS Development
            </h2>
            <p className="mt-6 text-gray-600 text-base leading-relaxed">
              TIAS OOD is a dedicated team of iOS engineers and designers with a
              passion for building applications that genuinely improve people's
              digital lives. Based in Ruse, Bulgaria, we combine technical
              excellence with a deep understanding of user needs.
            </p>
            <p className="mt-4 text-gray-600 text-base leading-relaxed">
              Our focus is on creating tools that are not only powerful under the
              hood, but also delightful to use — because we believe great software
              should feel effortless. From device security to performance
              optimization, we tackle the challenges that matter most to iOS users.
            </p>

            {/* Stats */}
            <div className="mt-10 flex">
              {stats.map((s) => (
                <div key={s.label}>
                  <p className="text-3xl font-bold text-amber-600">{s.value}</p>
                  <p className="text-xs text-gray-500 mt-1 font-medium">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
